/*eslint-disable */
import { customerNo, FEATURES } from "./constant";
const customer_wise_validations = {
  1920 : {
    phone_regex : /^[0-9]*$/,
    vehicle_no_regex : /^[0-9a-zA-Z\s\-_]+$/
  },
  1166 : {
    license_no : /^[a-zA-Z0-9? ]{1,17}$/
  }
}
export const AllRegex = {
  MobileNumber: customer_wise_validations[customerNo] && customer_wise_validations[customerNo].phone_regex ? customer_wise_validations[customerNo].phone_regex : /^\d{10}$/,
  BrazilMobileNumber: /^\d{12}$/,
  BrazilLicenseNo: '^[0-9]{11}$',
  LandlineNumber: /(^[0][1-9]{2}(-)[0-9]{8}$)/,
  LicenseNumber: customer_wise_validations[customerNo] && customer_wise_validations[customerNo].license_no ? customer_wise_validations[customerNo].license_no : /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
  VehicleNumber: customer_wise_validations[customerNo] && customer_wise_validations[customerNo].vehicle_no_regex ? customer_wise_validations[customerNo].vehicle_no_regex : (Number(localStorage.getItem("customerNumber")) != 1122 ? /^[A-Za-z]{2,3}[0-9]{0,2}(?:[A-Za-z])?(?:[A-Za-z]{0,2})?[0-9]{3,4}$/ : /^[A-Za-z]{3}[A-Za-z0-9]{4}$/),
  Name: /^[a-z A-Z]+$/,
  AltName: /^[a-z A-Z0-9-]+$/,
  Latitude: /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,9})?))$/,
  Longitude: /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,9})?))$/,
  Radius: /^\d{1,}(\.\d{0,})?$/,
  Address: /^[#.0-9a-zA-Z\s\/,-_()\[\]]+$/,
  Email: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  GSTIN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  PANIN: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
  Username: /^[A-Za-z0-9?,.&@_-]+$/,
  Pincode: /(^\d{6}$)|(^\d{6}-\d{5}$)/,
  AadharNumber: /^\d{4}[\s-]?\d{4}[\s-]?\d{4}$/,
  BankAccNumber: /(^\d{9,18}$)/,
  BankIFSCcode: /(^[A-Z]{4}0[A-Z0-9]{6}$)/,
  PositiveNumberWithPoint: /^[0-9.]+$/,
  ewayBillNumber: /^\d{12}$/,
  SpecialCharecter : /[^a-zA-Z0-9]+/,
  INT_OR_DECIMAL_WITH_MAX_5_DIGITS : /^[0-9]{1,2}(\.\d{0,5})?$/,
  WITHOUT_SPECIAL_CHARECTERS_AND_SPACE : /^[A-Za-z0-9?]+$/,
  INT_OR_DECIMAL_WITH_MAX_3_DECIMAL_POINTS : /^[0-9]{1,12}(\.\d{0,3})?$/
};

export const isMobileNumber = (val) => {
  AllRegex.MobileNumber.test(val);
};

export const isEwayBillNumber = (val) => {
  AllRegex.ewayBillNumber.test(val);
};

export const LandlineNumber = (val) => {
  AllRegex.LandlineNumber.test(val);
};

export const isLicenseNumber = (val) => {
  AllRegex.LicenseNumber.test(val);
};

export const isVehicleNumber = (val) => {
  AllRegex.VehicleNumber.test(val);
};

export const isName = (val) => {
  AllRegex.Name.test(val);
};

export const isLatitude = (val) => {
  AllRegex.Latitude.test(val);
};

export const isLongitude = (val) => {
  AllRegex.Longitude.test(val);
};

export const isRadius = (val) => {
  AllRegex.Radius.test(val);
};

export const isAddress = (val) => {
  AllRegex.Address.test(val);
};

export const isEmail = (val) => {
  AllRegex.Email.test(val);
};

export const isGSTIN = (val) => {
  AllRegex.GSTIN.test(val);
};

export const isPANIN = (val) => {
  AllRegex.PANIN.test(val);
};

export const isUsername = (val) => {
  return AllRegex.Username.test(val);
};

export const isPincode = (val) => {
  return AllRegex.Pincode.test(val);
};

export const isAadharNumber = (val) => {
  return AllRegex.AadharNumber.test(val);
};

export const isBankAccNumber = (val) => {
  return AllRegex.BankAccNumber.test(val);
};

export const isBankIFSCcode = (val) => {
  return AllRegex.BankIFSCcode.test(val);
};

export const isPositiveNo = (val) => {
  return AllRegex.PositiveNumberWithPoint.test(val);
};

export const isAltName = (val) => {
  return AllRegex.AltName.test(val);
}

export const isFileValid = (file, validTypes, maxFileSize) => {
  if (validTypes.indexOf(file.type?.split('/')?.[1]) === -1) {
    return { error: true, message: "Invalid file type. Allowed file types are - " + validTypes.join(", ") + "." };
  }

  if (file.size > maxFileSize) {
    return { error: true, message: `File is too large. File must be less than ${maxFileSize / 1000000}MB.` };
  }
  return { error: false, message: '' };
}

export const REQUIRED_MESSAGES = {
  FIELD_IS_REQUIRED: 'Required'
}